/* ============================================================
   LH · Tira de miniaturas horizontal en movil (ficha de producto)

   El tema monta las miniaturas como una instancia de Swiper en
   VERTICAL (gallery_type = thumbs_aside). Por eso el CSS solo no
   sirve: aunque pongas overflow-x:auto y flex-direction:row,
   Swiper controla el movimiento y reaplica estilos en linea.

   Se usa la API: changeDirection('horizontal'). Asi se conserva la
   sincronia tira <-> foto grande, que se perderia al destruir la
   instancia.

   ADEMAS hay que reconfigurar el conteo de slides. Heredado de la
   columna vertical, Swiper calcula cuantas miniaturas caben con un
   slidesPerView fijo y CORTA la ultima. Con slidesPerView:'auto'
   cada slide vale por su ancho real (64px del CSS) y se puede
   llegar hasta la ultima. Tambien se quita el margen derecho de la
   ultima, que si no suma 8px y vuelve a recortar.

   Se aplica bajo 990px y se revierte arriba, sin tocar escritorio.
   ============================================================ */
(function () {
  var LIMITE = 990;
  var ultimoModo = null;
  var original = null;

  function sublista() {
    return document.querySelector('.product__media-sublist');
  }

  function guardarOriginal(sw) {
    if (original) return;
    original = {
      slidesPerView: sw.params.slidesPerView,
      spaceBetween: sw.params.spaceBetween,
      slidesPerGroup: sw.params.slidesPerGroup,
      centeredSlides: sw.params.centeredSlides
    };
  }

  function margenUltima(sub, quitar) {
    var sl = sub.querySelectorAll('.swiper-slide');
    if (!sl.length) return;
    var ultima = sl[sl.length - 1];
    if (quitar) ultima.style.setProperty('margin-right', '0px', 'important');
    else ultima.style.removeProperty('margin-right');
  }

  function aplicar(forzar) {
    if (!document.body.classList.contains('template-product')) return;
    var sub = sublista();
    if (!sub) return;
    var sw = sub.swiper;
    if (!sw || typeof sw.changeDirection !== 'function') return;

    var movil = window.innerWidth < LIMITE;
    var modo = movil ? 'horizontal' : 'vertical';
    if (modo === ultimoModo && !forzar) return;

    guardarOriginal(sw);

    try {
      sw.changeDirection(modo, true);

      if (movil) {
        /* cada miniatura vale por su ancho real; asi no corta la ultima */
        sw.params.slidesPerView = 'auto';
        sw.params.slidesPerGroup = 1;
        sw.params.spaceBetween = 8;
        sw.params.centeredSlides = false;
        margenUltima(sub, true);
      } else {
        sw.params.slidesPerView = original.slidesPerView;
        sw.params.slidesPerGroup = original.slidesPerGroup;
        sw.params.spaceBetween = original.spaceBetween;
        sw.params.centeredSlides = original.centeredSlides;
        margenUltima(sub, false);
      }

      sw.update();
      /* segundo update: tras cambiar direccion, las medidas cambian */
      setTimeout(function () { try { sw.update(); } catch (e) {} }, 120);
      ultimoModo = modo;
    } catch (e) { /* si falla, se queda como estaba */ }
  }

  function arrancar() {
    aplicar(true);
    /* Swiper puede inicializarse despues de este script */
    var intentos = 0;
    var t = setInterval(function () {
      intentos++;
      aplicar(true);
      if (intentos > 12) clearInterval(t);
    }, 400);

    window.addEventListener('resize', function () { aplicar(false); }, { passive: true });
    window.addEventListener('orientationchange', function () {
      ultimoModo = null;
      setTimeout(function () { aplicar(true); }, 250);
    });
    /* Las imagenes tardan en cargar y cambian las medidas */
    window.addEventListener('load', function () { aplicar(true); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
